const checkIsoDate = date => {
  if (date) {
    try {
      const dateParsed = new Date(Date.parse(date));
      if (dateParsed.toISOString() === date) {
        return date;
      }
      return `${date}Z`;
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
  return date;
};

export default checkIsoDate;
